import directus from "api/services/directus";
import { SitewideBanner } from "custom-types/Directus";
import logError from "utils/logError";

const stringInsensitiveCompareWith = (t: string) => (s: string) =>
  s && t && s.toLowerCase() === t.toLowerCase();

const isValidForPath = (
  excludePaths: Array<{ path: string }>,
  path: string
) => {
  let valid = true;
  if (!path || !excludePaths || excludePaths.length === 0) {
    return valid;
  }

  for (const p of excludePaths) {
    if (p.path && path.startsWith(p.path)) {
      valid = false;
      break;
    }
  }

  return valid;
};

const filterBannersByLocation = async (
  // @ts-ignore (fix me please, do not replicate)
  banners,
  userLocationData: { city: string; state: string }
) => {
  if (!(banners && banners.length)) {
    return;
  }

  // @ts-ignore (fix me please, do not replicate)
  banners.forEach((banner) => {
    banner.show_license =
      banner.license_number &&
      userLocationData &&
      userLocationData.state === "California";
  });

  // @ts-ignore (fix me please, do not replicate)
  const needsLocationCheck = banners.find((b) => b.include_states);

  if (!needsLocationCheck) {
    return banners;
  }

  if (!userLocationData || !userLocationData.state) {
    return;
  }

  const citySpecificBanner = banners.find(
    // @ts-ignore (fix me please, do not replicate)
    (b) =>
      b.include_cities &&
      b.include_states &&
      b.include_cities.find(
        stringInsensitiveCompareWith(userLocationData.city)
      ) &&
      b.include_states.find(
        stringInsensitiveCompareWith(userLocationData.state)
      )
  );

  if (citySpecificBanner) {
    return [citySpecificBanner];
  }

  return banners.filter(
    // @ts-ignore (fix me please, do not replicate)
    (b) =>
      b.include_states &&
      (b.include_states.length === 0 ||
        b.include_states.indexOf(userLocationData.state) > -1)
  );
};

export const getCurrentSitewideBanner = async (
  countryCode: string,
  currentUrlPath: string,
  userLocationData: { city: string; state: string }
) => {
  try {
    const options = {
      params: {
        "filter[end_date_time][_gt]": "now",
        "filter[start_date_time][_lt]": "now",
        "filter[status][_eq]": "published",
        sort: "-start_date_time",
      },
    };

    const { data = [] } = await directus.get<SitewideBanner[]>(
      "/leafly_com_global_stripe_banner",
      options
    );

    const activeBanners = data.filter(
      ({ country_code, exclude_paths }) =>
        (!country_code ||
          (countryCode &&
            country_code.toLowerCase() === countryCode.toLowerCase())) &&
        isValidForPath(exclude_paths, currentUrlPath)
    );

    if (!activeBanners || !activeBanners.length) {
      return;
    }

    const [validBanner] = await filterBannersByLocation(
      activeBanners,
      userLocationData
    );

    return validBanner;
  } catch (e) {
    logError(e.message, {
      functionName: "getCurrentSitewideBanner",
      service: "directus",
      statusCode: e.statusCode,
    });

    return;
  }
};
